import React, { useState } from "react";
import { Container, Typography, Box, Paper, Chip } from "@mui/material";
import { styled } from "@mui/system";
import { motion } from "framer-motion";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t, i18n } = useTranslation();
 const [selectedYear, setSelectedYear] = useState("2021"); // string olarak

  const theme = useTheme();

const LightGradientContainer = styled(Container)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  background: "linear-gradient(135deg, #f5f7fa, #e1e8f0)", // Soft gradient background
  color: "#333",
  padding: "60px 20px",
  [theme.breakpoints.down('sm')]: {
    padding: "40px 20px", // Reduce padding for smaller screens
  },
}));

const LightCard = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "#ffffff", // White background for the card
  borderRadius: "15px", // Rounded corners
  boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)", // Soft shadow
  padding: "30px 20px",
  width: "100%",
  maxWidth: "800px",
  marginTop: theme.spacing(5),
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)", // Slight zoom effect
    boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.15)", // Hover shadow effect
  },
  [theme.breakpoints.down('sm')]: {
    padding: "20px 15px", // Smaller padding on mobile
    marginTop: theme.spacing(3),
  },
}));

const ImageBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "350px", // Moderate image size
  backgroundSize: "cover",
  backgroundPosition: "center",
  borderRadius: "15px",
  marginBottom: theme.spacing(3),
  transition: "transform 0.3s ease",
  "&:hover": {
    transform: "scale(1.08)", // Image zoom on hover
  },
  [theme.breakpoints.down('sm')]: {
    height: "250px", // Smaller image size on mobile
  },
}));

const MotionLightCard = motion(LightCard);

const timelineData = {
  2021: {
    year: "2021",
    description:
    t("about.desc"),
    image: "https://www.remora.com.tr/wp-content/uploads/2025/05/resim1.jpg",
  },
  2022: {
    year: "2022",
    description:
    t("about.desc1"),
    image: "https://www.remora.com.tr/wp-content/uploads/2025/05/bizkimiz.jpg",
  }, 
  2023: {
    year: "2023",
    description: 
    t("about.desc2"),
      
    image: "https://www.remora.com.tr/wp-content/uploads/2025/05/neta11-scaled.jpg",
  },
  2024: {
    year: "2024",
    description:
    t("about.desc3"),
    image: "https://www.remora.com.tr/wp-content/uploads/2025/05/netapros.jpg",
  },
};

  return (
    <LightGradientContainer maxWidth="xl">
      <Typography variant="h3" fontWeight="700" color="#1a1a1a" gutterBottom sx={{ fontSize: "2.5rem" }}>
      {t("about.title")}
    
      </Typography>
      <Typography variant="h5" color="#1a1a1a" fontWeight="600" gutterBottom sx={{ fontSize: "1.8rem" }}>
      {t("about.title2")}
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        paragraph
        sx={{
          maxWidth: "800px",
          fontSize: "1.2rem",
          color: "#333",
          textAlign: "center", // Center align text
          whiteSpace: "pre-line", // Maintain line breaks in the text
        }}
      >
         {t("about.text")}
        
      </Typography>

      {/* Seçmeli Yıl Butonları */}
      <Box
  sx={{
    display: "flex",
    justifyContent: "center",
    gap: 2,
    marginBottom: 5,
    backgroundColor: "#E3F2FD", // Daha soft bir mavi tonu
    padding: 2,
    borderRadius: "12px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Hafif gölge efekti
  }}
>
  {Object.keys(timelineData).map((year) => (
    <Chip
      key={year}
      label={year}
      clickable
      onClick={() => setSelectedYear(year)}
      sx={{
        fontSize: "18px",
        fontWeight: "bold",
        backgroundColor: selectedYear === year ? "#0077b6" : "#f0f0f0", // Daha doygun mavi
        color: selectedYear === year ? "#fff" : "#333",
        borderRadius: "50px",
        padding: "8px 16px",
        transition: "all 0.3s ease-in-out", // Geçiş efekti
        "&:hover": {
          backgroundColor: selectedYear === year ? "#005f8e" : "#e1e1e1",
          transform: "scale(1.05)", // Hafif büyüme efekti
        },
        [theme.breakpoints.down("sm")]: {
          fontSize: "14px",
          padding: "6px 14px",
        },
      }}
    />
  ))}
</Box>


      {/* Timeline Card */}
      <MotionLightCard
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <ImageBox style={{ backgroundImage: `url(${timelineData[selectedYear].image})` }} />
        <Typography variant="h4" color="primary" fontWeight="700" sx={{ marginTop: 2, fontSize: "2rem" }}>
          {timelineData[selectedYear].year}
        </Typography>
        <Typography variant="body1" sx={{ marginTop: 2, lineHeight: 1.7, color: "#555", fontSize: "1.1rem" }}>
          {timelineData[selectedYear].description}
        </Typography>
      </MotionLightCard>
    </LightGradientContainer>
  );
};

export default About;



